// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__32wr9","tabs":"LayoutWrapperSideNav_tabs__1iaaT","tab":"LayoutWrapperSideNav_tab__10FEA"};